import React, {lazy, Suspense} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Loading from 'components/shared-components/Loading';
import {APP_PREFIX_PATH} from 'configs/AppConfig';

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${APP_PREFIX_PATH}/dashboard`}
          component={lazy(() => import(`./dashboard`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/customers`}
          component={lazy(() => import(`./customers`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/cars`}
          component={lazy(() => import(`./cars`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/inbox`}
          component={lazy(() => import(`./inbox`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/calendar`}
          component={lazy(() => import(`./calendar`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/workflow`}
          component={lazy(() => import(`./workflow`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/invoices`}
          component={lazy(() => import(`./invoices`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/inventory`}
          component={lazy(() => import(`./inventory`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/services`}
          component={lazy(() => import(`./services`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/tags`}
          component={lazy(() => import(`./tags`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/support`}
          component={lazy(() => import(`./support`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/vendors`}
          component={lazy(() => import(`./vendors`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/profile`}
          component={lazy(() => import(`./profile`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/billing`}
          component={lazy(() => import(`./billing`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/settings`}
          component={lazy(() => import(`./settings`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/applications`}
          component={lazy(() => import(`./applications`))}
        />
        {/*<Route path={`${APP_PREFIX_PATH}/help`} component={lazy(() => import(`./help`))}/>*/}
        <Redirect
          from={`${APP_PREFIX_PATH}`}
          to={`${APP_PREFIX_PATH}/dashboard`}
        />
      </Switch>
    </Suspense>
  );
};

export default AppViews;
